import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { Box } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { processVideoMimeTypes } from "../../constants";
import Alert from "@mui/material/Alert";
import { withTranslation } from "react-i18next";

const styles = theme => ({
  videoPlayer: {
    width: "100%",
    "& .video-js.vjs-fluid,.video-js.vjs-16-9,.video-js.vjs-4-3,video.video-js,video.vjs-tech": {
      maxHeight: "calc(100vh - 290px)",
      position: "relative",
      width: "100%",
      height: "auto",
      maxWidth: "100%",
      paddingTop: "0",
      lineHeight: 0
    },
    "& .video-js.vjs-fullscreen": {
      height: "100%",
      maxHeight: "none",
      "& .vjs-tech": {
        height: "100%",
        maxHeight: "none"
      }
    },
    "& .vjs-control-bar": {
      lineHeight: 1
    }
  }
});

class VideoPlayer extends React.Component {
  componentDidMount() {
    this.player = videojs(
      this.videoNode,
      this.videoJsOptions(),
      function onPlayerReady() {
        console.log("onPlayerReady", this);
      }
    );
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.fullScreen && this.props.fullScreen) {
      this.player.requestFullscreen();
    }
  }

  videoJsOptions() {
    return {
      autoplay: false,
      playbackRates: [0.5, 1, 2],
      controls: true,
      fluid: true,
      sources: [
        {
          src: this.props.contentLink,
          type: this.props.mimeType
        }
      ]
    };
  }

  onVideoRef = node => {
    this.videoNode = node;
  };

  render() {
    const processing = processVideoMimeTypes.includes(this.props.mimeType);
    const { classes } = this.props;
    return (
      <Box className={classes.videoPlayer}>
        {processing && (
          <Box mb={2}>
            <Alert severity="info">
              {this.props.t("videoProcessing.view")}
            </Alert>
          </Box>
        )}
        <div data-vjs-player>
          <video
            ref={this.onVideoRef}
            className="video-js vjs-big-play-centered"
          ></video>
        </div>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(VideoPlayer));
